<template>
  <article
    class="hotsopt-trace-content"
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255,255 , 255, 0.4)"
  >
    <Title :clickFun="openBox" />

    <TagNav :tagActive="tagActive" :tags="navs" @changeNav="changeNav" />
    <!-- <div class="btn-change">
      <el-button v-if="changeBtn==0" @click="changecolose(0)" type="primary">展开筛选条件</el-button>
      <el-button v-if="changeBtn==1" @click="changecolose(1)" type="primary">收起筛选条件</el-button>
    </div>-->
    <section class="p30">
      <change-page
        ref="pagenav"
        :isShow="isProduct"
        :iscarType="iscar"
        :nowNav="tagActive"
        :content="false"
        :emotion="true"
        @getData="getData"
      ></change-page>
    </section>
    <div class="btn-change">
      <div v-if="changeBtn==0" @click="changecolose(0)" type="primary">
        全部条件
        <i class="icon_1"></i>
      </div>
      <div v-if="changeBtn==1" @click="changecolose(1)" type="primary">
        收起条件
        <i class="icon_2"></i>
      </div>
    </div>
    <section class="hotsopt-trace-rank">
      <SubTitle @datetype="getData2" ref="rankTitle" :data="rankTitle" />
      <div v-if="openshow">
        <div
          class="rank-chart-box"
          v-for="item in resdataList"
          :key="item.echartId"
          style="margin:20px 0"
          @click="goDetails(item)"
        >
          <scatterSingleAxis
            height="100%"
            width="100%"
            class="echarts"
            :id="item.echartId"
            :chartData="item"
            :ref="item.echartId"
            :times="detetypeRadio"
            :interval="interval2"
          />
        </div>
      </div>

      <div style="padding-bottom: 20px;
    text-align: center;">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-size="10"
          layout="pager,jumper"
          :total="recordcount"
          style="display:inline-block;vertical-align: middle;"
        ></el-pagination>
        <span
          style="maring-left:20px; display:inline-block;vertical-align: middle;   color: #606266;"
        >共{{recordcount}}篇</span>
      </div>
    </section>
    <section class="hotsopt-trace-report">
      <SubTitle :data="reportTitle" />
      <!-- <table class="report-table" cellpadding="0" cellspacing="0" border="1">
        <tbody>
          <tr>
            <td>报道标题</td>
            <td>宝马X1机油乳化问题投诉厂家无果</td>
          </tr>
          <tr>
            <td>整体情感</td>
            <td>负面</td>
          </tr>
          <tr>
            <td>主干标签</td>
            <td>
              <span>机油乳化</span>
              <span>投诉厂家</span>
              <span>体验很差</span>查看原文 >>
            </td>
          </tr>
          <tr>
            <td>热点持续时间</td>
            <td>3天</td>
          </tr>
          <tr>
            <td>提及产品</td>
            <td>宝马X1</td>
          </tr>
        </tbody>
      </table>-->
      <table class="report-table" cellpadding="0" cellspacing="0" border="1">
        <tbody>
          <tr>
            <td>报道标题</td>
            <td>{{hotTitle}}</td>
          </tr>
          <tr>
            <td>整体情感</td>
            <td v-if="my_emotion==3">重大负面</td>
            <td v-if="my_emotion==1">非负</td>
            <td v-if="my_emotion==2||my_emotion==-1">一般负面</td>
          </tr>
          <tr>
            <td>主干标签</td>
            <td>
              <span v-for="(item,index) in tagList" :key="index" v-show="index<5">{{item.tag_name}}</span>

              <!-- <span>体验很差</span> -->
              <!-- <span>体验很差</span> -->
              <a :href="urladd" v-if="tagList.length>0" target="_blank">查看原文 >></a>
            </td>
          </tr>
          <tr>
            <td>热点持续时间</td>
            <td>{{keep_hot_time}}</td>
          </tr>
          <tr>
            <td>提及产品</td>
            <td>
              <span v-for="(item,index) in proList" :key="index" style="margin-right:10px">{{item}}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="hotsopt-chart-title">
        <div class="line-chart-title">负面率</div>
        <div class="pie-chart-title">情感分析</div>
      </div>
      <div class="hotsopt-chart" v-if="openshow">
        <div class="line-chart">
          <LineChart
            v-if="this.resdataList.length>0"
            height="100%"
            width="100%"
            class="echarts"
            id="lineChart"
            :chartData="lineData"
            ref="lineChart"
          />
        </div>
        <div class="pie-chart">
          <Pie
            v-if="this.resdataList.length>0"
            height="100%"
            width="100%"
            ref="pieChart"
            class="echarts"
            type="bar"
            id="pie"
            :chartData="pieData"
          />
          <Legend v-if="this.resdataList.length>0" :data="reportLegend" />
        </div>
      </div>
    </section>
    <el-dialog title="名称解释" :visible.sync="visible" width="840px">
      <div style="height: 100%; max-height: 400px;　overflow-y:auto;">
        <TipsTable :Tdata="smdata" />
        <br />
        <TipsTable :Tdata="czdata" />
      </div>
      <br />
      <el-button @click="visible=false" style="margin-left: 700px" type="primary">确定</el-button>
    </el-dialog>
  </article>
</template>

<script>
import TagNav from "@/components/TagNavNew/TagNav";
import Tag from "@/components/Tag/Tag";
import scatterSingleAxis from "@/components/Chart/scatterSingleAxis";
import LineChart from "@/components/Chart/mixChart";
import Pie from "@/components/Chart/doublePie";
import Legend from "@/components/Legend/Legend";
import getCondition from "@/utils/mixins/getCondition";
import TipsTable from "@/components/Table/TipsTable";
import ChangePage from "@/components/Slect/change-page2";
export default {
  name: "HotspotTrace",
  //   mixins: [getCondition],
  components: {
    TagNav,
    Tag,
    TipsTable,
    scatterSingleAxis,
    LineChart,
    Pie,
    Legend,
    TipsTable,
    ChangePage
  },
  props: {
    showBar: {
      type: Boolean
    }
  },
  data() {
    return {
      visible: false,
      rankTitle: {
        subTitle: "厂商维度汇总-负面",
        title: "媒体报道热点排行",
        show: true,
        clickFun: this.handleDialogShow,
        timeshow: true,
        hourtime: true
      },
      scatterSingleAxisData: {
        echartId: "scatterSingleAxis", // id
        height: "100%",
        width: "100%",
        color: [
          "#1e3490",
          "#5bd1ed",
          "#a9ddcc",
          "#ffe27d",
          "#ffb299",
          "#fc8ea9",
          "#ecc9f5",
          "#ecc9f5",
          "#ecc9f5",
          "#ecc9f5"
        ],
        singleAxisData: [
          "12a",
          "1a",
          "2a",
          "3a",
          "4a",
          "5a",
          "6a",
          "7a",
          "8a",
          "9a",
          "10a",
          "11a",
          "12p",
          "1p",
          "2p",
          "3p",
          "4p",
          "5p",
          "6p",
          "7p",
          "8p",
          "9p",
          "10p",
          "11p"
        ],
        titleData: ["宝马X1问题"],
        seriesData: [
          [0, 2, 3],
          [0, 1, 1],
          [0, 0, 2],
          [0, 3, 3],
          [0, 4, 0],
          [0, 5, 0],
          [0, 6, 0],
          [0, 7, 0],
          [0, 8, 0],
          [0, 9, 0],
          [0, 10, 0],
          [0, 11, 2],
          [0, 12, 4],
          [0, 13, 1],
          [0, 14, 1],
          [0, 15, 3],
          [0, 16, 4],
          [0, 17, 6],
          [0, 18, 4],
          [0, 19, 4],
          [0, 20, 3],
          [0, 21, 3],
          [0, 22, 2],
          [0, 23, 5]
        ]
      },
      smdata: {
        one: "名词说明",
        two: "说明",
        acrtarr: [
          {
            tit: [
              { one: "媒体热点" },
              {
                one:
                  "指热度值超过了【媒体话题热度阈值】的新闻文章会被系统持续的追踪更新浏览量、评论数据，连续5日低于【媒体话题热度阈值*20%】，将不再跟踪"
              }
            ]
          },
          {
            tit: [
              { one: "媒体热度值" },
              {
                one:
                  "媒体热度值 = (回复数量 * (浏览量*10%) ) / (已经发布天数*50%)，该值被每天记录"
              }
            ]
          },
          {
            tit: [
              { one: "负面率" },
              {
                one:
                  "指用户话题中出现了负面情感的声量占比  负面率 =（负面声量数/声量总数）* 100%"
              }
            ]
          },
          {
            tit: [
              { one: "主要提及" },
              {
                one: "出现在文章话题里面（被多少个用户提及）的次数最多的关键字"
              }
            ]
          },
          {
            tit: [
              { one: "话题情感" },
              {
                one: "目前情感属性分为正面、负面、中性3类"
              }
            ]
          }
        ]
      },
      czdata: {
        one: "非指标类名词解释",
        two: "说明",
        acrtarr: [
          {
            tit: [
              { one: "媒体话题热度阈值" },
              {
                one: "当前系统配置值为：%Media_focus_Threshold%"
              }
            ]
          }
        ]
      },
      reportTitle: {
        subTitle: "",
        title: "媒体热门报道单篇详细分析",
        show: false,
        clickFun: this.handleDialogShow
      },
      lineData: {
        height: "100%",
        width: "100%",
        // title: "负面率",
        chartData: {
          负面率: {
            "0-100": 12.0,
            "101-200": 24.2,
            "201-300": 35.3,
            "301.400": 34.5
          }
        }, // 数据
        echartId: "lineChart", // id
        type: ["line"], // 图表类型
        chartTitle: " ", // 图表     subtext: '长安马自达新品发布', // 图表副标题
        splitLineShow: true,
        axisTickShow: true,
        boundaryGap: false,
        axisLabelShow: true,
        interval: 0,
        rotate: 0,
        symbolType: ["circle"],
        yAxisConfig: [
          {
            position: "left",
            offset: 0,
            formatter: "",
            min: 0,
            max: 5,
            interval: 1
            // name: "负面率"
          }
        ],
        tooltipData: [{ name: "负面率", formatter: "%" }],
        xTool: "楼",
        grid: {
          right: 0,
          left: 0,
          top: 0
        },
        line: [{ color: "#ef0615", type: "solid" }] // 线
      },
      pieData: {
        chartData: [{}], // 数据
        echartId: "pie", // id
        type: "pie", // 图表类型
        color: ["#4464e6", "#ef0615", "#67e1ff", "rgba(0, 0,0, .2)"],
        radius: [["40%", "70%"]],
        center: [["50%", "50%"]],
        formatter: "{b|{b}}\n{per|{d}%}",
        name: "",
        height: "90%",
        width: "100%"
      },
      reportLegend: [
        { color: "#4464e6", label: "正面" },
        { color: "#ef0615", label: "负面" },
        { color: "#67e1ff", label: "中性" }
      ],

      // 修改
      navs: ["产品维度汇总", "品牌维度汇总", "厂商维度汇总"], //标题
      isProduct: false, //是否显示产品
      iscar: false,
      tagActive: 0,
      loading1: false,
      loading: true,
      tagnew: 1,
      serch: {},
      resdataList: [],
      hotTitle: "",
      Hot_value_history: "",
      hot_media_value: "",
      my_emotion: "",
      keep_hot_time: 0,
      proList: [],
      tagList: [],
      urladd: "",
      openshow: true,
      resdataListcontent: [],
      page: 1,
      recordcount: 0,
      detetypeRadio: 1,
      axisshow: false,
      interval2: 2,
      hot_thres: "",
      changeBtn: 0
    };
  },
  methods: {
    openBox() {
      this.visible = true;
    },
    // 解释名词
    handleDialogShow() {
      this.visible = !this.visible;
    },
    // 导航点击
    getTagNav(index) {
      this.tagActive = index;
    },

    getData(value) {
      this.page = 1;
      this.serch = value;
      console.log(3333333);
      if (
        value.start_time &&
        value.end_time &&
        value.start_time == value.end_time
      ) {
        this.rankTitle.hourtime = true;

        this.$refs.rankTitle.btnTime(1);
      } else {
        this.rankTitle.hourtime = false;
        this.$refs.rankTitle.btnTime(0);
      }
      let emotion = "";
      if (this.serch.emotionRadio == 1) {
        emotion = "正面";
      } else if (this.serch.emotionRadio == 2) {
        emotion = "中性";
      } else if (this.serch.emotionRadio == 3) {
        emotion = "负面";
      } else {
        emotion = "全部";
      }

      this.rankTitle.subTitle = this.navs[this.tagActive] + "-" + emotion;

      // this.HotMediaArtcleRank();
    },
    getData2(value) {
      this.page = 1;
      this.detetypeRadio = value;
      this.openshow = false;
      console.log(444444);
      this.HotMediaArtcleRank();
    },
    //获取信息

    async HotMediaArtcleRank() {
      // this.openshow=false
      this.loading = true;
      console.log(22222);
      let brand = "";
      let data_type = null;
      let vendor = "";

      if (this.tagActive == 2) {
        data_type = 2;
        vendor = this.serch.vendor;
      } else if (this.tagActive == 1) {
        data_type = 0;
        vendor = "";
      } else if (this.tagActive == 0) {
        data_type = 1;
        vendor = "";
      }
      if (this.tagActive == 1) {
        brand = this.serch.brand;
      } else {
        brand = "";
      }

      let params = {
        page: this.page,
        pagesize: 10,
        brand_ids: brand,
        pro_ids: this.serch.pro_ids,
        vendor: vendor,
        my_emotion: this.serch.emotionRadio,
        media_ids: this.serch.media,
        start_time: this.serch.start_time,
        end_time: this.serch.end_time,
        source: this.serch.sourceRadio,
        date_type: this.detetypeRadio
      };
      this.getObj(params);
      let res = await this.$api.hotspot.HotMediaArtcleRank(params);
      if (res.data.error === 0) {
        this.recordcount = res.data.data.total;
        let resdataList1 = [...res.data.data.resdata_list];
        // this.hot_thres=res.data.data.hot_thres;
        this.czdata.acrtarr[0].tit[1].one =
          "当前系统配置值为：" + res.data.data.hot_thres;

        this.resdataListcontent = [...res.data.data.resdata_list];
        let resdataList = resdataList1.map((item, index) => {
          let singleAxisData = [];
          let valueArry = [];
          let titleData = [];
          item.Hot_value_history.forEach(element => {
            singleAxisData.unshift(element.date);
            valueArry.unshift(element.hot_value);
          });
          let max = Math.max.apply(null, valueArry);
          let min = Math.min.apply(null, valueArry);

          console.log("singleAxisData", max,min);
          let title = "";
          if (item.tag_list.length > 0) {
            title = item.pro_name + "-" + item.tag_list[0].tag_name || "";
          } else {
            title = item.pro_name;
          }
          titleData.push(title);
          let color = [
            "#1f3491",
            "#5bd1ed",
            "#a2d7c5",
            "#ffe27e",
            "#fdaf98",
            "#fc8ea9",
            "#edc9f5",
            "#3dcca6",
            "#73b0ff",
            "#c7000a"
          ];
          // let color = this.randomColor();

          // colors.push(color);
          let colors = [];
          colors.push(color[index]);
          let seriesData = [];
          valueArry.forEach((num, index2) => {
            let arry = [0, index2, num];
            seriesData.push(arry);
          });

          let scatterSingleAxisData = {
            echartId: item.article_id, // id
            height: "100%",
            width: "100%",
            color: colors,
            singleAxisData: singleAxisData,
            titleData: titleData,
            seriesData: seriesData,
            differ:{
                max:max,
                min:min
            }
          };
          console.log('scatterSingleAxisData',scatterSingleAxisData)
          return scatterSingleAxisData;
        });

        this.resdataList = resdataList;
        if (resdataList1.length > 0) {
          this.hotTitle = resdataList1[0].title;
          this.Hot_value_history = "";
          this.hot_media_value = "";

          this.my_emotion = resdataList1[0].my_emotion;
          this.keep_hot_time = resdataList1[0].keep_hot_time;
          this.proList = resdataList1[0].pro_list;
          this.tagList = resdataList1[0].tag_list;
          this.urladd = resdataList1[0].urladd;

          // 饼图
          this.pieData.chartData[0] = {
            正面: resdataList1[0].sub_data.front,
            负面: resdataList1[0].sub_data.negative,
            中性: resdataList1[0].sub_data.mid
          };

          if (this.$refs.pieChart) {
            this.$refs.pieChart.dealData(this.pieData);
          }
          // 曲线图
          let Floor_emotionList = resdataList1[0].sub_data.Floor_emotion;
          let maxnum = Math.max.apply(
            Math,
            Floor_emotionList.map(function(o) {
              return o.negative_rate;
            })
          );

          let str = Math.ceil(maxnum / 6); //最大数除6的结果
          let Num = Math.pow(10, str.toString().length - 1); //获取结果的位数
          str = str.toString().substring(0, 0.01); //取出结果第一位数字+1 * 10的位数-1的次方

          let aveNum = (maxnum * 100 + 0.01).toFixed(2);

          let intervaly = (aveNum / 5).toFixed(2);

          this.lineData.yAxisConfig = [
            {
              position: "left",
              offset: 0,
              formatter: "",
              min: 0,
              max: aveNum,

              interval: aveNum / 2
              // name: "负面率"
            }
          ];

          this.lineData.interval = "auto";
          let obj = {};
          resdataList1[0].sub_data.Floor_emotion.map((count, index) => {
            Reflect.set(
              obj,
              count.floor,
              (count.negative_rate * 100).toFixed(2)
            ); //反转
          });
          this.lineData.chartData = {
            负面率: obj
          };

          if (this.$refs.lineChart) {
            this.$refs.lineChart.dealData(this.lineData);
          }
        } else {
          this.hotTitle = "";
          this.Hot_value_history = "";
          this.hot_media_value = "";

          this.my_emotion = "";
          this.keep_hot_time = "";
          this.proList = "";
          this.tagList = "";
          this.urladd = "";

          // 饼图
          this.pieData.chartData[0] = {
            正面: 0,
            负面: 0,
            中性: 0
          };

          if (this.$refs.pieChart) {
            this.$refs.pieChart.dealData(this.pieData);
          }
          // 曲线图
          if (resdataList1.length > 0) {
            let Floor_emotionList = resdataList1[0].sub_data.Floor_emotion;
            let maxnum = Math.max.apply(
              Math,
              Floor_emotionList.map(function(o) {
                return o.negative_rate;
              })
            );

            let str = Math.ceil(maxnum / 6); //最大数除6的结果
            let Num = Math.pow(10, str.toString().length - 1); //获取结果的位数
            str = str.toString().substring(0, 0.01); //取出结果第一位数字+1 * 10的位数-1的次方

            let aveNum = (maxnum * 100 + 0.01).toFixed(2);

            let intervaly = (aveNum / 5).toFixed(2);

            this.lineData.yAxisConfig = [
              {
                position: "left",
                offset: 0,
                formatter: "",
                min: 0,
                max: aveNum,

                interval: aveNum / 2
                // name: "负面率"
              }
            ];

            this.lineData.interval = "auto";
            let obj = {};
            resdataList1[0].sub_data.Floor_emotion.map((count, index) => {
              Reflect.set(
                obj,
                count.floor,
                (count.negative_rate * 100).toFixed(2)
              ); //反转
            });
            this.lineData.chartData = {
              负面率: obj
            };

            if (this.$refs.lineChart) {
              this.$refs.lineChart.dealData(this.lineData);
            }
          }
        }
      }
      this.openshow = true;
      this.loading = false;
    },

    changeNav(index) {
      this.loading1 = true;
      if (index == 0) {
        this.isProduct = true;
        this.tagnew = 2;
        this.iscar = false;
        this.tagActive = index;
        // this.tableHeader[1].label = "产品";
      } else if (index == 1) {
        this.isProduct = false;
        this.tagnew = 1;
        this.iscar = false;
        this.tagActive = index;
        // this.tableHeader[1].label = "品牌";
      } else if (index == 2) {
        this.isProduct = false;
        this.tagnew = 0;
        this.iscar = true;
        this.tagActive = index;
        // this.tableHeader[1].label = "厂商";
      }
      // this.mediaChannelTops()
      this.$refs.pagenav.changeData(index);

      let emotion = "";
      if (this.serch.emotionRadio == 1) {
        emotion = "正面";
      } else if (this.serch.emotionRadio == 2) {
        emotion = "中性";
      } else if (this.serch.emotionRadio == 3) {
        emotion = "负面";
      } else {
        emotion = "全部";
      }
      this.rankTitle.subTitle = this.navs[index] + "-" + emotion;
      //   this.voiceData.subTitle = this.navs[index];
    },
    goDetails(item) {
      this.resdataListcontent.forEach(list => {
        if (item.echartId == list.article_id) {
          this.hotTitle = list.title;
          this.Hot_value_history = "";
          this.hot_media_value = "";

          this.my_emotion = list.my_emotion;
          this.keep_hot_time = list.keep_hot_time;
          this.proList = list.pro_list;
          this.tagList = list.tag_list;
          this.urladd = list.urladd;

          // 饼图
          this.pieData.chartData[0] = {
            正面: list.sub_data.front,
            负面: list.sub_data.negative,
            中性: list.sub_data.mid
          };

          if (this.$refs.pieChart) {
            this.$refs.pieChart.dealData(this.pieData);
          }
          // 曲线图
          let Floor_emotionList = list.sub_data.Floor_emotion;
          let maxnum = Math.max.apply(
            Math,
            Floor_emotionList.map(function(o) {
              return o.negative_rate;
            })
          );
          let str = Math.ceil(maxnum / 6); //最大数除6的结果
          let Num = Math.pow(10, str.toString().length - 1); //获取结果的位数
          str = str.toString().substring(0, 0.01); //取出结果第一位数字+1 * 10的位数-1的次方

          let aveNum = (maxnum * 100 + 0.01).toFixed(2);

          let intervaly = (aveNum / 5).toFixed(2);

          this.lineData.yAxisConfig = [
            {
              position: "left",
              offset: 0,
              formatter: "",
              min: 0,
              max: aveNum,

              interval: aveNum / 2
              // name: "负面率"
            }
          ];
          let obj = {};
          list.sub_data.Floor_emotion.map((count, index) => {
            Reflect.set(obj, count.floor, count.negative_rate * 100); //反转
          });
          this.lineData.chartData = {
            负面率: obj
          };

          if (this.$refs.lineChart) {
            this.$refs.lineChart.dealData(this.lineData);
          }
        }
      });

      let scrollTop = document.documentElement.scrollTop;
      var timer = setInterval(x => {
        scrollTop += 20;
        document.documentElement.scrollTop = scrollTop;
        if (scrollTop > 1600) {
          clearInterval(timer);
        }
      }, 10);
    },
    // 对象去空
    getObj(data) {
      for (var key in data) {
        if (data[key] === "") {
          delete data[key];
        }
      }
      return data;
    },
    // 随机颜色
    randomColor() {
      var arr = [
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9"
      ];
      var chars = "";
      for (var i = 0; i < 6; i++) {
        chars += arr[Math.round((Math.random() * 100) % 15)];
      }

      return "#" + chars;
    },
    testxlc() {
      this.openshow = true;
      let that = this;
      this.$nextTick(function() {
        that.HotMediaArtcleRank();
      });
    },
    handleCurrentChange(e) {
      this.page = e;
      this.HotMediaArtcleRank();
    },
    changecolose(val) {
      if (val == 0) {
        this.changeBtn = 1;
      } else {
        this.changeBtn = 0;
      }
      this.$refs.pagenav.changeshow(val);
    }
  },
  watch: {
    showBar(newV, oldV) {
      this.openshow = false;
      let that = this;
      this.$nextTick(function() {
        that.testxlc();
      });
    }
  },
  mounted() {
    this.$refs.pagenav.changeshow(1);
  },
  created() {}
};
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/_mixin.scss";

.hotsopt-trace-content {
  width: 100%;
  padding-bottom: $padding;
  box-sizing: border-box;
  .hotsopt-trace-rank {
    height: auto;
    @include common;
    margin-top: 0;
    padding-right: 0px;
    .rank-chart-box {
      width: 100%;
      height: 50px;
      box-sizing: border-box;
      position: relative;
      left: 30px;
      padding: 0;
    }
  }
  .hotsopt-trace-report {
    height: 771px;
    @include common;
    padding-right: 0;
    .report-table {
      width: 90%;
      margin: 50px $padding $padding;
      border: solid 1px #d4d4d4;
      border-collapse: collapse;
      tr {
        height: 50px;
        border: solid 1px #d4d4d4;
        td {
          text-align: center;
          border: solid 1px #d4d4d4;
        }
        td:nth-of-type(1) {
          // text-align: right;
          width: 235px;
          box-sizing: border-box;
          // padding-right: 40px;
        }
        td:nth-of-type(2) {
          padding-left: 30px;
        }
      }
      tr:nth-of-type(2) {
        td:nth-of-type(2) {
          color: #ef0615;
        }
      }
      tr:nth-of-type(3) {
        td:nth-of-type(2) {
          span {
            width: auto;
            height: 25px;
            display: inline-block;
            padding: 0 5px;
            background-color: #dee5ff;
            border-radius: 5px;
            border: solid 1px #b5c1ec;
            color: #3d5acf;
            line-height: 25px;
            text-align: center;
            margin-right: 10px;
            cursor: pointer;
          }
        }
      }
    }
    .hotsopt-chart-title {
      display: flex;
      justify-content: flex-start;
      width: 100%;
      box-sizing: border-box;

      margin: 0 $padding;
      .line-chart-title,
      .pie-chart-title {
        font: {
          size: 16px;
          weight: 900;
        }
        line-height: 34px;
        color: #000000;
        text-align: left;
      }
      .line-chart-title {
        // width: 60%;
        flex: 1;
      }
      .pie-chart-title {
        width: 400px;
      }
      .pie-chart {
        width: 400px;
      }
    }
    .hotsopt-chart {
      display: flex;
      justify-content: flex-start;
      position: relative;
      width: calc(100% - 60px);
      box-sizing: border-box;
      margin: 0 $padding;
      .line-chart {
        width: calc(100% - 400px);
        height: 285px;
      }
      .pie-chart {
        width: 400px;
        height: 300px;
        position: relative;
        .legend-view {
          position: absolute;
          top: 0;
          width: 100%;
          height: 285px;
          @include flex;
          justify-content: center;
          flex-direction: column;
          padding-left: 10px;
          margin: 0;
        }
      }
    }
  }
}
.center {
  text-align: center;
}
.btn-change {
  text-align: center;
  font-size: 14px;
  height: 60px;
  line-height: 60px;
  color: #000000;
  // font-weight: bold;
  div {
    display: inline-block;
    cursor: pointer;
  }
}
.icon_1 {
  display: inline-block;
  width: 14px;
  height: 8px;
  background: url("../../../assets/img/icon_1.png");
  background-size: 100% 100%;
}
.icon_2 {
  display: inline-block;
  width: 14px;
  height: 8px;
  background: url("../../../assets/img/icon_1.png");
  background-size: 100% 100%;
  transform: rotate(180deg);
}
</style>
